import { RiArrowRightLine } from '@remixicon/react'
import { Link } from 'react-router'

import { TemplateDownloadList } from '#app/components/mocra/template-download-list.tsx'
import { Page } from '#app/components/page.tsx'
import { Divider } from '#app/components/ui/divider.tsx'
import { Typography } from '#app/components/ui/typography.tsx'

import { type SectionContent } from '#app/routes/mocra+/_sections+/section-data.ts'

export function SectionDetail({ section }: { section: SectionContent }) {
	return (
		<Page
			title={section.title}
			description={<span className="mt-3 block">{section.description}</span>}
			className="space-y-8"
		>
			<Divider />
			<section className="space-y-3">
				<Typography.Subtitle>Key obligations</Typography.Subtitle>
				<ul className="text-muted-foreground list-disc space-y-2 pl-5 text-sm leading-6">
					{section.obligations.map((item) => (
						<li key={item}>{item}</li>
					))}
				</ul>
			</section>

			<section className="space-y-3">
				<Typography.Subtitle>
					Evidence regulators expect to see
				</Typography.Subtitle>
				<ul className="text-muted-foreground list-disc space-y-2 pl-5 text-sm leading-6">
					{section.evidence.map((item) => (
						<li key={item}>{item}</li>
					))}
				</ul>
			</section>

			<section className="space-y-3">
				<Typography.Subtitle>
					Intake sections that populate this section
				</Typography.Subtitle>
				<ul className="text-muted-foreground list-disc space-y-2 pl-5 text-sm leading-6">
					{section.intakeSections.map((intake) => (
						<li key={intake.to}>
							<Link
								to={intake.to}
								className="flex items-center gap-1 underline-offset-2 transition-colors hover:underline"
							>
								<span className="text-muted-foreground">{intake.label}</span>
								<RiArrowRightLine className="text-muted-foreground h-3.5 w-3.5" />
							</Link>
						</li>
					))}
				</ul>
			</section>

			<section className="space-y-3">
				<Typography.Subtitle>Relevant SOP templates</Typography.Subtitle>
				<TemplateDownloadList templates={section.templates} />
			</section>

			<section className="space-y-3">
				<Typography.Subtitle>Risk of non-compliance</Typography.Subtitle>
				<ul className="text-muted-foreground list-disc space-y-2 pl-5 text-sm leading-6">
					{section.consequences.map((item) => (
						<li key={item}>{item}</li>
					))}
				</ul>
			</section>

			<section className="space-y-3">
				<Typography.Subtitle>Further reading</Typography.Subtitle>
				<ul className="text-muted-foreground list-disc space-y-2 pl-5 text-sm leading-6">
					{section.references.map((reference) => (
						<li key={reference.to}>
							<Link
								to={reference.to}
								target="_blank"
								rel="noreferrer"
								className="text-primary underline underline-offset-2"
							>
								{reference.label}
							</Link>
						</li>
					))}
				</ul>
			</section>

			<Divider />
			<p className="text-muted-foreground text-xs">
				Use these notes to brief leadership and justify remediation work. As you
				complete the intake, the Generate Package step merges your answers into
				each SOP so you can demonstrate compliance with {section.title}.
			</p>
		</Page>
	)
}
